(() => {
  const LinkedProductsSku = window.LinkedProductsSku;

  if (!LinkedProductsSku || window.__collectionLinkedProductsSkuInitialized) {
    return;
  }

  window.__collectionLinkedProductsSkuInitialized = true;

  const state = {
    frame: null,
    observer: null
  };

  const renderLinkedProducts = () => {
    if (!Array.isArray(window.products)) {
      return;
    }

    document.querySelectorAll('[data-collection-linked-products-sku]').forEach(wrapper => {
      const linkedProductsContainer = wrapper.querySelector('[data-linked-products-sku]');
      const productId = Number(wrapper.dataset.productId);
      const currentProduct = window.products.find(product => product.id === productId);

      if (!linkedProductsContainer || !currentProduct) {
        return;
      }

      const linkedProducts = LinkedProductsSku.getLinkedProducts(window.products, currentProduct.sku);
      const activeLinked = linkedProducts.find(linked => linked.sku === currentProduct.sku);

      if (!linkedProducts.length) {
        linkedProductsContainer.innerHTML = '';
        linkedProductsContainer.classList.add('is-empty');
        return;
      }

      linkedProductsContainer.classList.remove('is-empty');

      const markup = linkedProducts.map(linked => {
        const color = LinkedProductsSku.getColorLabel(linked.title);
        return `
          <a href="${linked.url}" class="${linked.sku === activeLinked?.sku ? 'active' : ''} ${!linked.available ? 'unavailable' : ''}" data-color="${color}">
            <img src="${linked.image}" alt="${linked.title}">
          </a>
        `;
      }).join('');

      if (linkedProductsContainer.innerHTML !== markup) {
        linkedProductsContainer.innerHTML = markup;
      }
    });
  };

  const queueRender = () => LinkedProductsSku.queueRender(state, renderLinkedProducts);

  const init = async () => {
    LinkedProductsSku.observeMutations({
      root: document.body,
      state,
      selectors: ['[data-collection-linked-products-sku]', '[data-linked-products-sku]', '.product-card'],
      onChange: queueRender
    });

    window.addEventListener('shopify:section:load', queueRender);

    if (!LinkedProductsSku.getStoredProducts()) {
      await LinkedProductsSku.fetchAllProducts();
    } else {
      window.products = LinkedProductsSku.getStoredProducts();
    }

    queueRender();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
